/**
 * Skeleton (design-system §6: skeletons, nunca spinners). El pulso se desactiva con
 * `prefers-reduced-motion`.
 */
import { cn } from '../../lib/cn';

import type { HTMLAttributes } from 'react';

export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-pulse rounded-fm-md bg-fm-bg-sunken motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  );
}

/** Bloque de líneas para listas y tablas en carga. */
export function SkeletonLines({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-fm-2', className)}>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} className="h-fm-touch w-full" />
      ))}
    </div>
  );
}
